// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"135":"dcd5e606","440":"10057654","527":"9bfc75a6","651":"68f4ea6d","667":"ea588c91","761":"65ca7cdf"}[chunkId] + ".css";
};